module.exports = __webpack_public_path__ + "static/media/arrowup.195350f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/arrowup.png
// module id = 12
// module chunks = 0